import React from "react";
import {Pagination} from "@mui/material";
import styles from "./TablePagination.module.css"

interface TablePaginationProps {
    pageNumber: number
    itemsPerPage: number
    totalItems: number
    onPageChange: (newPage: number) => void
}

export const TablePagination: React.FC<TablePaginationProps> = ({
                                                                    pageNumber,
                                                                    itemsPerPage,
                                                                    totalItems,
                                                                    onPageChange
                                                                }) => {
    const startItem = totalItems !== 0 ? (pageNumber * itemsPerPage + 1) : 0;
    const endItem = Math.min((pageNumber + 1) * itemsPerPage, totalItems);

    const handlePaginationClick = (_event: React.ChangeEvent<unknown>, page: number) => {
        onPageChange(page - 1)
    }

    return <div className={styles.wrapper}>
        {totalItems !== 0 && <div className={styles.info}>
            {`Showing ${startItem}-${endItem} of ${totalItems}`}
        </div>
        }
        <Pagination
            page={pageNumber + 1}
            onChange={handlePaginationClick}
            count={Math.ceil(totalItems / itemsPerPage)}
            size={'large'}
            showFirstButton
            showLastButton
            variant="outlined"
            shape="rounded"
            boundaryCount={2}
            sx={{
                '& .MuiPaginationItem-root.Mui-selected': {
                    backgroundColor: 'var(--side-menu) !important',
                    color: '#fff !important',
                    borderColor: 'var(--side-menu) !important',
                    '&:hover': {
                        backgroundColor: 'var(--gold) !important',
                        color: 'var(--side-menu) !important',
                    },
                },
            }}
        />
    </div>
}
